module.exports = __webpack_public_path__ + "img/dianpian.prt.34b2d9b5.jpg";